import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { formatNaira } from "@/lib/api";
import { useBasket } from "@/context/BasketContext";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export const ProductCard = ({ product, index = 0 }) => {
  const { add } = useBasket();
  const navigate = useNavigate();
  const img = product.images?.[0];
  const outOfStock = product.stock <= 0;

  const addToList = (e) => {
    e.preventDefault();
    e.stopPropagation();
    add(product);
    toast.success(`${product.name} added to your list`, {
      action: { label: "View list", onClick: () => navigate("/basket") },
    });
  };
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group flex flex-col bg-white border-2 border-black rounded-lg overflow-hidden shadow-brutal hover:-translate-y-1 hover:shadow-brutal-lg transition-all duration-200 animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative aspect-square bg-brand-cream overflow-hidden border-b-2 border-black">
        {img ? (
          <img
            src={img}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-brand-blue/40 font-display font-bold">
            No image
          </div>
        )}
        {product.featured && (
          <span className="absolute top-2 left-2 bg-brand-gold text-black text-xs font-bold px-2 py-1 border-2 border-black rounded">
            Featured
          </span>
        )}
        {outOfStock && (
          <span className="absolute top-2 right-2 bg-white text-brand-blue text-xs font-bold px-2 py-1 border-2 border-black rounded">
            Out of stock
          </span>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-display font-bold text-base leading-tight text-brand-black line-clamp-2 group-hover:text-brand-blue">
          {product.name}
        </h3>
        {product.unit && <p className="mt-1 text-xs font-medium text-brand-blue/60">{product.unit}</p>}
        <p className="mt-2 text-lg font-black text-brand-blue">{formatNaira(product.price)}</p>
        <button
          onClick={addToList}
          data-testid={`add-to-list-${product.slug}`}
          className="mt-3 inline-flex items-center justify-center gap-1.5 w-full bg-brand-gold text-black text-sm font-semibold py-2 border-2 border-black rounded-md hover:-translate-y-0.5 active:translate-y-0 transition-transform duration-200"
        >
          <Plus className="w-4 h-4" strokeWidth={2.5} /> Add to list
        </button>
      </div>
    </Link>
  );
};
